import React from 'react';
import styles from './ApartmentSvg.scss';
import ApartmentSvgImage from '../../assets/img/ValApartment.svg';
import { ISubcode } from './ValuationWidget';

export interface IApartmentSvgProps {
    variant: 'apartment' | ISubcode;
}

const ApartmentSvg: React.FC<React.PropsWithChildren<IApartmentSvgProps>> = ({ variant = null }) => {
    return (
        <div className={styles.apartmentSvg + ' ' + styles[variant]}>
            <ApartmentSvgImage />
        </div>
    );
};

export default ApartmentSvg;
